/**
 * @generated SignedSource<<8bd544768147ad4061cfbd0425b3396d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PublishingStatus = "acknowledged" | "failed" | "inprogress" | "succeeded";
import { FragmentRefs } from "relay-runtime";
export type publishingFailedNotice_PublishingV2Fragment$data = {
  readonly messages: ReadonlyArray<{
    readonly additionalMessage: string | null;
    readonly message: string;
  }>;
  readonly status: PublishingStatus;
  readonly " $fragmentType": "publishingFailedNotice_PublishingV2Fragment";
};
export type publishingFailedNotice_PublishingV2Fragment$key = {
  readonly " $data"?: publishingFailedNotice_PublishingV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"publishingFailedNotice_PublishingV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "publishingFailedNotice_PublishingV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublishingMessageV2",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PublishingV2",
  "abstractKey": null
};

(node as any).hash = "d7c1cb75d166271fd281f923c4ed8e26";

export default node;
